var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"default-btn template-btn py-spc6 px-10 ",class:[ _vm.title ? _vm.classname + ' block' : ' hidden' ],attrs:{"to":_vm.url}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }